import { render, staticRenderFns } from "./ExcelView.vue?vue&type=template&id=5281b575&scoped=true&"
import script from "./ExcelView.vue?vue&type=script&lang=ts&"
export * from "./ExcelView.vue?vue&type=script&lang=ts&"
import style0 from "./ExcelView.vue?vue&type=style&index=0&id=5281b575&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5281b575",
  null
  
)

export default component.exports